<template>
  <vx-card :title="chartParams.name">
    <!-- CHARTS -->
    <template>
      <div class="mt-10">
        <apexchart
          type="bar"
          height="250"
          :options="chartParams.chartOptions"
          :series="chartParams.series"
        />
      </div>
    </template>
    <!-- DATA -->
    <div
      v-if="chartParams"
      class="flex justify-between text-center mt-4"
    >
      <div
        class="w-1/3"
      >
        <p class="mt-4">{{ chartParams.series[0].name }}</p>
        <p v-if="isPercent" class="mb-4 text-3xl font-semibold">
          {{ chartParams.series[0].data[0] }} %
        </p>
        <p v-else class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.series[0].data[0]) }}
        </p>
      </div>
      <div
        class="w-1/3 border border-solid d-theme-border-grey-light border-b-0"
      >
        <p class="mt-4">V.S.</p>
        <p class="mb-4 text-3xl font-semibold">
          {{ chartParams.series[1].data[0] > 0 ? ((chartParams.series[0].data[0] / chartParams.series[1].data[0]) * 100).toFixed(2) : 0 }}%
        </p>
      </div>
      <div
        class="w-1/3"
      >
        <p class="mt-4">{{ chartParams.series[1].name }}</p>
        <p v-if="isPercent" class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.series[1].data[0]) }} %
        </p>
        <p v-else class="mb-4 text-3xl font-semibold">
          {{ formatThousandNumb(chartParams.series[1].data[0]) }}
        </p>
      </div>
    </div>
  </vx-card>
</template>

<script>
import utilsMixin from "@/mixins/utilsMixin";

export default {
	name: "DuoBarChart",
	mixins: [utilsMixin],
	props: {
		chartParams: Object,
		isPercent: Boolean
	}
};
</script>
